"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require("material-ui/SvgIcon");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WaterTap = function WaterTap(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    (0, _extends3.default)({ className: "custom-icon", viewBox: "0 0 24 24" }, props),
    _react2.default.createElement("path", {
      d: "M 10.00,5.00 C 10.00,5.00 10.00,10.00 10.00,10.00 10.00,10.00 9.00,10.00 9.00,10.00 9.00,10.00 9.00,5.00 9.00,5.00 9.00,5.00 5.00,5.00 5.00,5.00 5.00,5.00 5.00,13.00 5.00,13.00 5.00,13.00 9.00,13.00 9.00,13.00 9.00,13.00 9.00,12.00 9.00,12.00 9.00,12.00 10.00,12.00 10.00,12.00 10.00,12.00 10.00,17.00 10.00,17.00 10.00,17.00 9.00,17.00 9.00,17.00 9.00,17.00 9.00,14.00 9.00,14.00 9.00,14.00 5.00,14.00 5.00,14.00 5.00,14.00 5.00,19.00 5.00,19.00 5.00,19.00 12.00,19.00 12.00,19.00 12.00,19.00 12.00,17.00 12.00,17.00 12.00,17.00 13.00,17.00 13.00,17.00 13.00,17.00 13.00,19.00 13.00,19.00 13.00,19.00 19.00,19.00 19.00,19.00 19.00,19.00 19.00,17.00 19.00,17.00 19.00,17.00 21.00,17.00 21.00,17.00 21.00,17.00 21.00,21.00 21.00,21.00 21.00,21.00 3.00,21.00 3.00,21.00 3.00,21.00 3.00,3.00 3.00,3.00 3.00,3.00 21.00,3.00 21.00,3.00 21.00,3.00 21.00,15.00 21.00,15.00 21.00,15.00 19.00,15.00 19.00,15.00 19.00,15.00 19.00,10.00 19.00,10.00 19.00,10.00 13.00,10.00 13.00,10.00 13.00,10.00 13.00,15.00 13.00,15.00 13.00,15.00 12.00,15.00 12.00,15.00 12.00,15.00 12.00,9.00 12.00,9.00 12.00,9.00 19.00,9.00 19.00,9.00 19.00,9.00 19.00,5.00 19.00,5.00 19.00,5.00 10.00,5.00 10.00,5.00 Z",
      id: "path-1"
    })
  );
};

exports.default = WaterTap;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/custom-icons/edcr.js
// module id = ../lib/egov-ui-kit/custom-icons/edcr.js
// module chunks = 504